import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-custom-input-file',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './custom-input-file.component.html',
  styleUrl: './custom-input-file.component.scss'
})
export class CustomInputFileComponent {
  selectedFileName: string = '';
  @Input() id: string = '';
  @Output() onFileSelected: EventEmitter<File | null> = new EventEmitter<File | null>();

  constructor() {}

  triggerFileInput() {
    const fileInput = document.getElementById('file-input-'+this.id) as HTMLInputElement;
    if (fileInput) {
      fileInput.click();
    }
  }

  async loadFiles(filesEvent: any) {
    const input = filesEvent.target as HTMLInputElement;
    if (input && input.files && input.files.length > 0) {
      this.selectedFileName = input.files[0].name;
    } else {
      this.selectedFileName = '';
    }

    this.onFileSelected.emit(input.files ? input.files[0] : null);
  }
}
